const $window = $(window);
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 768px)');

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// resizing
import {showMovie} from "../include/module";
showMovie();

// headerToggle
import {headerToggle} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

import {scrollAnimation} from "../include/module";
$(window).on('load', function(){
  setTimeout(function () {
    scrollAnimation();
  }, 100);
});
$(window).on('scroll', function(){
  scrollAnimation();
});



// WEBPACK FOOTER //
// ./src/mobpsycho3rd/assets/js/music/script.js